import { render } from "./employee_register.html?vue&type=template&id=5aa60d16&external"
import script from "./employee_register.js?vue&type=script&lang=js&external"
export * from "./employee_register.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__